import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import {
  Form,
  Input,
  Button,
  InputNumber,
  message,
  Select,
  PageHeader,
  Layout,
  Col,
  Space,
  Row,
  Radio,
  DatePicker,
} from "antd";
import "./style.scss";
import { useHistory, useParams } from "react-router";
import { useSelector } from "react-redux";
import DiscountService from "../../services/DiscountService";
import R2Footer from "../../components/Footer";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

const { Option } = Select;

export default function AddDiscount(props) {
  const formRef = React.createRef();
  const history = useHistory();
  const params = useParams();

  const [form] = Form.useForm();
  const typeValue = Form.useWatch("type", form);
  const [types, setType] = useState(["DOLLAR", "PERCENTAGE"]);
  const [cusineId, setCusinesId] = useState();
  const [dataByID, setDataById] = useState({});
  const { Content } = Layout;

  const adminRestaurant = useSelector((state) => state.admin);

  const disabledDate = (current, option) => {
    let fromDate = form.getFieldValue("valid_from");
    if (fromDate?._d && option === "End") {
      return current && current <= dayjs(fromDate?._d).startOf("day");
    }
    return current && current <= dayjs().startOf("day");
  };
  const getDetailsById = async () => {
    const detailsById = await DiscountService.getDiscountByID(params.itemId);
    formRef.current?.setFieldsValue({
      name: detailsById.name,
      value: detailsById.value,
      type: detailsById.type,
      count_to_check: dayjs("2023-01-26T13:39:11.000Z", "YYYY-MM-DD"),
      count_to_discount: dayjs(),
      is_multi_use: detailsById.discount_codes[0]?.is_multi_use,
      code: detailsById.discount_codes[0]?.code,
      link: detailsById.discount_codes[0]?.code,
      valid_from: dayjs(
        detailsById.discount_codes[0]?.valid_from,
        "YYYY-MM-DD"
      ),
      valid_till: dayjs(
        detailsById.discount_codes[0]?.valid_till,
        "YYYY-MM-DD"
      ),
      d_id: detailsById.discount_codes[0]?.id,
    });
    setDataById(detailsById);
  };

  useEffect(() => {
    if (params.itemId) {
      getDetailsById();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.itemId]);

  const onGenerateCode = async () => {
    const newCode = await DiscountService.generateCode();
    formRef.current.setFieldsValue({ code: newCode.code });
  };

  const addAdmin = async (values) => {
    const testimonials = {
      name: values.name,
      type: values.type,
      value: parseInt(values.value),
      count_to_check: 1,
      count_to_discount: 1,
      // restaurant_id: adminRestaurant,
    };
    const reqData = {
      discount_id: 6,
      // restaurant_id: adminRestaurant,
      code: values.code,
      valid_from: dayjs(values.valid_from).format("YYYY-MM-DDTHH:mm:ssZ"),
      valid_till: dayjs(values.valid_till).format("YYYY-MM-DDTHH:mm:ssZ"),
      is_active: true,
      is_multi_use: values.is_multi_use,
    };
    if (params.itemId) {
      await DiscountService.updateDiscounts(testimonials, params.itemId);
      reqData.discount_id = parseInt(params.itemId);
      await DiscountService.updateDiscountsCode(
        reqData,
        dataByID.discount_codes[0]?.id
      );
      message.success("Updated Successfully");
      history.push("/business/discounts");
    } else {
      const response = await DiscountService.addDiscounts(testimonials);
      console.log("ata",response)
      if(response?.data)
      {
      reqData.discount_id = response?.data?.id;
   
      await DiscountService.addDiscountsCode(reqData);
      message.success("Added Successfully");
      history.push("/business/discounts");
      }
      else
      message.error(response.msg)
    }

    
  };
  const generateCode = async () => {
    console.log(
      "Form",
      form.getFieldsValue().valid_till,
      dayjs(form.getFieldsValue().valid_till).format("YYYY-MM-DDTHH:mm:ssZ")
    );
  };

  return (
    <Layout className="u-page-layout">
      <Content>
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          <PageHeader
            style={{ minHeight: 80 }}
            className="d-flex items-center page-header-business"
            title={
              <div className="flex items-center">
              <div
                    className="cursor-pointer flex"
                    onClick={() => history.goBack()}
                    style={{marginRight:"10px"}}
                  >
                    <svg
                      width="25"
                      height="16"
                      viewBox="0 0 25 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM25 7L1 7V9L25 9V7Z"
                        fill="black"
                      />
                    </svg>
                  </div>
             <div>{params.menuId || params.itemId ? "Edit New Discount" : "Add New Discount"}</div> 
             </div>}
          />
          <div className="add_card content-container-business">
            <h3 className="head_text">Details</h3>
            <p className="heading">Add name and Description of the food.</p>
            <Form
              ref={formRef}
              form={form}
              onFinish={addAdmin}
              layout="vertical"
              className="add-form"
            >
              <Form.Item
                name="name"
                label="Name"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder="Enter name" />
              </Form.Item>
              <Row>
                <Col span={12}>
                  <Form.Item
                    name="type"
                    label="Type"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select defaultValue={cusineId}>
                      {types &&
                        types.map((item) => (
                          <Option value={item}>{item}</Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={5}>
                  <Form.Item
                    name="value"
                    label="Value"
                    className="ml-2"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <InputNumber
                      addonBefore={
                        typeValue ? (typeValue === "DOLLAR" ? "$" : "%") : ""
                      }
                      style={{ width: "100%" }}
                      min={0}
                      width={400}
                    />
                  </Form.Item>
                </Col>
                <Col span={7}>
                  <Form.Item
                    name="is_multi_use"
                    label="Code Usage"
                    className="ml-2"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    style={{ textAlign: "left" }}
                  >
                    <Radio.Group>
                      <Radio value={false}> Single Use </Radio>
                      <Radio value={true}> Multiple Use </Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  <Form.Item
                    name="valid_from"
                    label="Valid From"
                    rules={[
                      {
                        required: true,
                        message: "Please provide the discount date",
                      },
                    ]}
                  >
                    <DatePicker
                      format="YYYY-MM-DD"
                      disabledDate={(c) => disabledDate(c, "Start")}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="valid_till"
                    className="ml-2"
                    label="Valid Till"
                    rules={[
                      {
                        required: true,
                        message: "Please provide the discount date",
                      },
                    ]}
                  >
                    <DatePicker
                      format="YYYY-MM-DD"
                      disabledDate={(c) => disabledDate(c, "End")}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  <Form.Item label="Code">
                    <Input.Group compact>
                      <Form.Item
                        name="code"
                        noStyle
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <Input style={{ width: "calc(100% - 130px)" }} />
                      </Form.Item>
                      <Button
                        type="primary"
                        onClick={onGenerateCode}
                        className="comp_btn"
                      >
                        Generate code
                      </Button>
                    </Input.Group>
                  </Form.Item>
                </Col>
                {/* <Col span={12}>
                  <Form.Item label="Link" className="ml-2">
                    <Input.Group compact>
                      <Form.Item
                        name="link"
                        className="ml-2"
                        noStyle
                        rules={[
                          {
                            required: false,
                            message: "Please provide the discount",
                          },
                        ]}
                      >
                        <Input
                          style={{ width: "calc(100% - 100px)" }}
                          disabled={params.itemId ? true : false}
                        />
                      </Form.Item>
                      <Button type="primary" className="comp_btn">
                        Copy URL 
                      </Button>
                    </Input.Group>
                  </Form.Item>
                </Col> */}
              </Row>
              <Form.Item className="button-form">
                <Button type="primary" htmlType="submit">
                  Save & Add
                </Button>
              </Form.Item>
            </Form>
          </div>
        </Space>
      </Content>
      <R2Footer />
    </Layout>
  );
}
